/* ==========================================================================
   Blessed Bangles — bb-global.js
   Header drawer, search overlay, accordions, hero slider, sticky bars,
   show-more lists, WhatsApp buttons, lightweight sliders.
   ========================================================================== */
(function () {
  'use strict';
  var BB = (window.BB = window.BB || {});
  var cfg = window.BBConfig || {};

  /* ---------- generic drawers (menu) ---------- */
  function openDrawer(id) {
    var d = BB.qs('#' + id), ov = BB.qs('#bb-overlay'); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); ov && ov.classList.add('is-open'); document.body.classList.add('bb-lock');
  }
  function closeDrawers() {
    BB.qsa('.bb-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    var ov = BB.qs('#bb-overlay'); ov && ov.classList.remove('is-open'); document.body.classList.remove('bb-lock');
    var s = BB.qs('#bb-search'); if (s) s.classList.remove('is-open');
  }
  BB.openDrawer = openDrawer; BB.closeDrawers = closeDrawers;
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-drawer-open]'); if (t) { e.preventDefault(); openDrawer(t.dataset.drawerOpen); return; }
    t = e.target.closest('[data-drawer-close]'); if (t) { e.preventDefault(); closeDrawers(); return; }
    t = e.target.closest('[data-search-open]'); if (t) { e.preventDefault(); var s = BB.qs('#bb-search'); if (s) { s.classList.add('is-open'); var i = BB.qs('input[type=search]', s); i && setTimeout(function () { i.focus(); }, 50); } return; }
    t = e.target.closest('[data-search-close]'); if (t) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('bb:overlay:click', closeDrawers);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- accordions ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bb-acc__btn'); if (!btn) return;
    var item = btn.closest('.bb-acc__item'), acc = btn.closest('.bb-acc');
    var open = item.classList.contains('is-open');
    if (acc && acc.dataset.single === 'true') BB.qsa('.bb-acc__item.is-open', acc).forEach(function (i) { i.classList.remove('is-open'); BB.qs('.bb-acc__btn', i).setAttribute('aria-expanded', 'false'); });
    item.classList.toggle('is-open', !open); btn.setAttribute('aria-expanded', String(!open));
  });

  /* ---------- show more ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-show-more]'); if (!btn) return;
    var wrap = BB.qs(btn.dataset.showMore); if (!wrap) return;
    var step = Number(btn.dataset.step || 6);
    var hidden = BB.qsa('[data-more-item][hidden]', wrap);
    hidden.slice(0, step).forEach(function (el) { el.hidden = false; el.classList.add('bb-fade'); });
    if (hidden.length <= step) btn.hidden = true;
  });

  /* ---------- simple slider (hero / gallery) ---------- */
  function Slider(root) {
    var track = BB.qs('[data-slides]', root); if (!track) return;
    var slides = BB.qsa('[data-slide]', track), i = 0, n = slides.length, timer;
    var dots = BB.qs('[data-dots]', root), auto = Number(root.dataset.autoplay || 0);
    if (n < 2) { root.classList.add('is-single'); return; }
    if (dots) { dots.innerHTML = slides.map(function (_, k) { return '<button type="button" aria-label="Slide ' + (k + 1) + '" data-dot="' + k + '"></button>'; }).join(''); }
    function go(k) {
      i = (k + n) % n;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === i); s.setAttribute('aria-hidden', j === i ? 'false' : 'true'); });
      if (dots) BB.qsa('[data-dot]', dots).forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
      root.dispatchEvent(new CustomEvent('bb:slide', { detail: { index: i } }));
    }
    function restart() { clearInterval(timer); if (auto > 0) timer = setInterval(function () { go(i + 1); }, auto * 1000); }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-prev]'); if (t) { go(i - 1); restart(); return; }
      t = e.target.closest('[data-next]'); if (t) { go(i + 1); restart(); return; }
      t = e.target.closest('[data-dot]'); if (t) { go(Number(t.dataset.dot)); restart(); }
    });
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); restart(); } x0 = null; }, { passive: true });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    go(0); restart();
    root.bbSlider = { go: go };
  }
  BB.Slider = Slider;
  BB.qsa('[data-slider]').forEach(Slider);
  document.addEventListener('shopify:section:load', function (e) { BB.qsa('[data-slider]', e.target).forEach(Slider); });

  /* ---------- horizontal scroll rows with arrows ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-scroll]'); if (!b) return;
    var row = BB.qs(b.dataset.scroll); if (!row) return;
    row.scrollBy({ left: (Number(b.dataset.dir) || 1) * row.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ---------- sticky bars (PDP / bundle) ---------- */
  function stickyBar(bar) {
    var target = BB.qs(bar.dataset.stickyFor); if (!target) return;
    var io = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting; var below = entries[0].boundingClientRect.top < 0;
      var on = !visible && below; bar.classList.toggle('is-on', on); document.body.classList.toggle('has-stickybar', on);
    }, { threshold: 0 });
    io.observe(target);
  }
  BB.qsa('[data-sticky-for]').forEach(stickyBar);

  /* ---------- WhatsApp buttons ----------
     Message is built at click time from data-* attributes + live state exposed by the
     owning widget through a data-wa-source id (element with dataset.waState JSON). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-wa]'); if (!a) return;
    e.preventDefault();
    var num = (a.dataset.waNumber || cfg.whatsapp || '').replace(/[^\d]/g, ''); if (!num) return;
    var lines = [];
    var tpl = a.dataset.waTemplate || cfg.waTemplate || 'Hi Blessed Bangles 👋 I want to order:';
    var src = a.dataset.waSource ? BB.qs(a.dataset.waSource) : null;
    var state = null; try { state = src && src.dataset.waState ? JSON.parse(src.dataset.waState) : null; } catch (err) {}
    lines.push(tpl);
    var product = (state && state.product) || a.dataset.waProduct; if (product) lines.push('• ' + product);
    var tier = (state && state.tier) || a.dataset.waTier; if (tier) lines.push('• ' + (cfg.waTierLabel || 'Offer') + ': ' + tier);
    var variants = (state && state.variants) || a.dataset.waVariants; if (variants) lines.push('• ' + (cfg.waVariantLabel || 'Colour') + ': ' + variants);
    var extras = state && state.extras; if (extras) lines.push('• ' + extras);
    var price = (state && state.priceText) || a.dataset.waPrice; if (price) lines.push('• ' + (cfg.waPriceLabel || 'Price') + ': ' + price);
    var url = a.dataset.waUrl || location.href.split('?')[0]; url += (url.indexOf('?') > -1 ? '&' : '?') + 'utm_source=whatsapp&utm_medium=button&utm_campaign=' + encodeURIComponent(a.dataset.waCampaign || 'theme');
    lines.push(url);
    if (cfg.waFooter) lines.push(cfg.waFooter);
    var href = 'https://wa.me/' + num + '?text=' + encodeURIComponent(lines.join('\n'));
    BB.track('bb_whatsapp_click', { product: product || '', tier: tier || '', price: price || '', source: a.dataset.waCampaign || 'theme' });
    window.open(href, '_blank', 'noopener');
  });

  /* ---------- lazy video play on click ---------- */
  document.addEventListener('click', function (e) {
    var p = e.target.closest('[data-video-play]'); if (!p) return;
    var wrap = p.closest('[data-video]'); var v = wrap && BB.qs('video', wrap);
    if (v) { v.controls = true; v.muted = false; v.play(); p.hidden = true; }
    var ifr = wrap && wrap.dataset.embed; if (ifr && !v) { wrap.innerHTML = '<iframe src="' + ifr + '" allow="autoplay; encrypted-media" allowfullscreen loading="lazy" style="position:absolute;inset:0;width:100%;height:100%;border:0"></iframe>'; }
  });

  /* ---------- product card swatches ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-sw]'); if (!sw) return;
    var card = sw.closest('[data-pcard]'); if (!card) return;
    BB.qsa('[data-sw]', card).forEach(function (s) { s.classList.toggle('is-on', s === sw); });
    var img = BB.qs('[data-card-img]', card); if (img && sw.dataset.img) { img.src = sw.dataset.img; img.removeAttribute('srcset'); }
    var price = BB.qs('[data-card-price]', card);
    if (price) { var p = Number(sw.dataset.price), c = Number(sw.dataset.compare); price.innerHTML = BB.money(p) + (c > p ? '<span class="bb-compare">' + BB.money(c) + '</span>' : ''); }
    var atc = BB.qs('[data-card-atc]', card);
    if (atc) { atc.dataset.addVariant = sw.dataset.variantId; var ok = sw.dataset.available === 'true'; atc.disabled = !ok; BB.qs('.btn__label', atc).textContent = ok ? (cfg.addLabel || 'Add to bag') : (cfg.soldOutLabel || 'Sold out'); }
  });

  /* ---------- select defaults (customer address country) ---------- */
  BB.qsa('select[data-default]').forEach(function (s) { var d = s.dataset.default; if (!d) return; for (var i = 0; i < s.options.length; i++) { if (s.options[i].value === d || s.options[i].text === d) { s.selectedIndex = i; break; } } });

  /* ---------- floating country picker ---------- */
  document.addEventListener('click', function (e) {
    var root = BB.qs('[data-geo]'); if (!root) return;
    var panel = BB.qs('[data-geo] .bb-geo__panel'), btn = BB.qs('[data-geo-toggle]');
    if (e.target.closest('[data-geo-toggle]')) {
      var open = !root.classList.contains('is-open');
      root.classList.toggle('is-open', open); panel.hidden = !open; btn.setAttribute('aria-expanded', String(open));
      return;
    }
    if (e.target.closest('[data-geo-close]') || !e.target.closest('[data-geo]')) {
      root.classList.remove('is-open'); panel.hidden = true; btn.setAttribute('aria-expanded', 'false');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var root = BB.qs('[data-geo]'); if (!root || !root.classList.contains('is-open')) return;
    root.classList.remove('is-open'); BB.qs('[data-geo] .bb-geo__panel').hidden = true; BB.qs('[data-geo-toggle]').setAttribute('aria-expanded', 'false');
  });

  /* ---------- copy to clipboard ---------- */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-copy]'); if (!c) return;
    try { navigator.clipboard.writeText(c.dataset.copy); BB.toast(cfg.copiedLabel || 'Copied'); } catch (err) {}
  });

  /* ---------- theme editor: keep sections lively ---------- */
  document.addEventListener('shopify:section:select', function (e) { var w = BB.qs('[data-wheel-root]', e.target); if (w && window.BBWheel) window.BBWheel.open(true); });
})();
